<template>
  <StandardIconBloc
    icon="check-square-fill"
    backColor="rgb(234,230,255)"
    frontColor="rgb(82,67,170)"
  >
    <slot></slot>
  </StandardIconBloc>
</template>

<script>
import StandardIconBloc from "./StandardIconBloc.vue";
export default {
  name: "TaskBloc",
  components: { StandardIconBloc },
};
</script>
